import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=32223b2a&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=32223b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32223b2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterApps: require('/opt/buildhome/repo/components/FooterApps.vue').default,FooterMenu: require('/opt/buildhome/repo/components/FooterMenu.vue').default})
